import { call, put, select, take } from 'redux-saga/effects';

import { PROJECTION } from 'constants/ApiConstants';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchGroup, selectGroup, setGroupManagementReady } from 'modules/groups/actions';
import { getSelectedGroup, getSelectedGroupId } from 'modules/groups/selectors';

import { putAndWait } from '../../app/sagas';

import { FETCH_GROUP_FAILURE, FETCH_GROUP_SUCCESS, SELECT_GROUP } from '../actionTypes';

/** @param {{ type: string, payload?: { groupId?: string } }} action */
const isSelectGroupWithId = ({ type, payload }) => type === SELECT_GROUP && Boolean(payload?.groupId);

function* initializeGroupManagementPage() {
  let selectedGroupId = yield select(getSelectedGroupId);

  if (!selectedGroupId) {
    const { payload } = yield take(isSelectGroupWithId);
    selectedGroupId = payload.groupId;
  }

  const selectedGroup = yield select(getSelectedGroup);

  const params = [selectedGroupId, { projection: PROJECTION.CONFIG }, {}];

  if (selectedGroupId === selectedGroup?.id) {
    yield putAndWait(fetchGroup(...params));
  } else {
    yield put(selectGroup(...params));
    yield take([FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE]);
  }
  yield put(setGroupManagementReady(true));
}

function* onGroupManagementWorker() {
  yield call(initializeGroupManagementPage);
}

export default function* groupManagementSaga() {
  yield scopeToPage([PATH.GROUP_MANAGEMENT], onGroupManagementWorker);
}
